import { useState } from 'react';
import { MemberOtpClient } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMemberOtpApi = () => {
    const apiClient = new MemberOtpClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (deliveryMethod: string) => {
        setIsLoading(true);
        try {
            await apiClient.createMemberOTP(deliveryMethod);
        } catch (err: any) {
            setError(err.message || 'Error creating Member Otp');
        } finally {
            setIsLoading(false);
        }
    };

    const verify = async (otp: string) => {
        setIsLoading(true);
        try {
           return await apiClient.verifyOtp(otp);
        } catch (err: any) {
            setError(err.message || 'Error verifying Otp');
        } finally {
            setIsLoading(false);
        }
    };

    return { 
        create, 
        verify,
        isLoading, 
        error 
    };
};